import type { ReactNode } from 'react';

type SectionHeadingProps = {
  label: string;
  title: ReactNode;
  description?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
  className?: string;
};

export default function SectionHeading({
  label,
  title,
  description,
  align = 'left',
  tone = 'light',
  className = '',
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  const labelColor = tone === 'dark' ? 'text-accent-400' : 'text-primary-600';
  const titleColor = tone === 'dark' ? 'text-background-50' : 'text-foreground-950';
  const descColor = tone === 'dark' ? 'text-background-200' : 'text-foreground-600';

  return (
    <div
      className={`${isCenter ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'} ${className}`}
    >
      <div className={`flex items-center gap-3 ${isCenter ? 'justify-center' : ''}`}>
        <span className="h-px w-8 bg-accent-500" />
        <span className={`label-mono ${labelColor}`}>{label}</span>
      </div>
      <h2 className={`display-title mt-5 text-4xl md:text-5xl lg:text-6xl ${titleColor}`}>
        {title}
      </h2>
      {description ? (
        <p className={`mt-5 text-base leading-relaxed md:text-lg ${descColor}`}>{description}</p>
      ) : null}
    </div>
  );
}